import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AdminPageNotFound } from "../../styled/AllImages";

const PageNotFound = ({ btnUrl, btnLabel }) => {
  const { t } = useTranslation();
  return (
    <Card
      style={{
        maxWidth: "32rem",
        border: "none",
        backgroundColor: "transparent",
        margin: "0 auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "2.5rem",
      }}
    >
      <Card.Img
        variant="top"
        style={{ width: "200px", height: "200px", objectFit: "cover" }}
        src={AdminPageNotFound}
      />
      <Card.Body
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Card.Title
          style={{ fontWeight: "bold", fontSize: "3rem", color: "#525355" }}
        >
          {t("oh_no")}
        </Card.Title>
        <Card.Text
          style={{
            textAlign: "center",
            marginBottom: "20px",
            fontSize: "1rem",
            fontWeight: "bold",
            color: "#525355",
          }}
        >
          {t("page_not_found")}
        </Card.Text>
        <Link to={btnUrl}>
          <Button variant="primary">{t(btnLabel)}</Button>
        </Link>
      </Card.Body>
    </Card>
  );
};

export default PageNotFound;
